<template>
    <ul :class="isHeating ? 'temperatureBox heating' : 'temperatureBox'">
        <li>
            <p class="blue">{{ name }}</p>
        </li>
        <li v-if="name !== '熔体温度'">
            <p>加热状态：</p>
            <p v-if="name !== '熔体温度'" :class="Number(heatingState) === 1 ? 'orange' : ''">
                {{ Number(heatingState) === 1 ? "加热中" : "未加热" }}
            </p>
            <p v-else>无</p>
        </li>
        <li v-if="name !== '熔体温度'">
            <p>设定温度：</p>
            <p v-if="name !== '熔体温度'">{{ setTemp }}℃</p>
            <p v-else>无</p>
        </li>
        <li>
            <p>实测温度：</p>
            <p :class="Number(currentTemp) > 0 ? 'heating-alone' : ''">{{ currentTemp }}℃</p>
        </li>
    </ul>
</template>

<script>
export default {
    name: "TempB",
    props: {
        name: {
            type: String
        },
        heatingState: {
            type: [String, Number]
        },
        setTemp: {
            type: [String, Number],
            default: 0
        },
        currentTemp: {
            type: [String, Number],
            default: 0
        }
    },
    emits: [],
    computed: {
        isHeating() {
            return Number(this.heatingState) === 1;
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
ul {
    li {
        p {
            font-size: 14px !important;
            color: #fff !important;
        }

        .blue {
            color: #2a82e4 !important;
        }

        .orange {
            color: #fa8052 !important;
        }

        .red {
            color: #e25453 !important;
        }
    }
}
</style>
